import React, { useState, useEffect, useMemo, useRef } from 'react';
import { db, paths } from '../../firebase/config';
import { 
    collection, 
    query, 
    onSnapshot, 
    doc, 
    updateDoc, 
    deleteDoc, 
    setDoc, 
    getDocs,
    writeBatch
} from "firebase/firestore";
import { useAuth, logAuditoria } from '../../context/AuthContext';
import { LoadingSpinner } from '../../components/LoadingSpinner';
import { Button } from '../../components/Button';
import { Modal } from '../../components/Modal';

// --- ÍCONES ---
const EditIcon = () => <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" /></svg>;
const TrashIcon = () => <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>;
const PlusIcon = () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>;
const UserAddIcon = () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" /></svg>;
const FilterIcon = () => <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" /></svg>;
const StarIcon = () => <svg className="w-4 h-4 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" /></svg>;
const BadgeIcon = () => <svg className="w-4 h-4 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
const ArrowRightIcon = () => <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 5l7 7-7 7M5 5l7 7-7 7" /></svg>;
const UploadIcon = () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" /></svg>;

export const GerenciadorDashboard = () => {
    const { userProfile } = useAuth();
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState('turmas'); 

    // --- DADOS ---
    const [turmas, setTurmas] = useState([]);
    const [companhias, setCompanhias] = useState([]);
    const [pelotoes, setPelotoes] = useState([]);
    const [cadetes, setCadetes] = useState([]);

    // --- FILTROS DE SELEÇÃO ---
    const [selectedTurmaId, setSelectedTurmaId] = useState('');
    const [selectedCiaId, setSelectedCiaId] = useState('');
    const [selectedPelotaoId, setSelectedPelotaoId] = useState('');

    // --- MODAL ---
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState(''); 
    const [currentItem, setCurrentItem] = useState(null);
    const [formData, setFormData] = useState({}); 
    const [processing, setProcessing] = useState(false);

    // --- ALOCAÇÃO E IMPORTAÇÃO CSV ---
    const fileInputRef = useRef(null);
    const [importProgress, setImportProgress] = useState('');
    const [cadetesDisponiveis, setCadetesDisponiveis] = useState([]); 
    const [cadeteParaAlocar, setCadeteParaAlocar] = useState(''); 
    const [ordemPelotaoManual, setOrdemPelotaoManual] = useState('');
    const [filtroNomeCadete, setFiltroNomeCadete] = useState('');
    const [filtroOrigemCia, setFiltroOrigemCia] = useState(''); 
    const [filtroOrigemPelotao, setFiltroOrigemPelotao] = useState('');

    // --- COMANDO ---
    const [todosUsuarios, setTodosUsuarios] = useState([]);
    const [usuarioSelecionadoComando, setUsuarioSelecionadoComando] = useState('');
    const [listaUsuariosDropdown, setListaUsuariosDropdown] = useState([]); 

    // CARREGAMENTO DE DADOS
    useEffect(() => {
        setLoading(true);
        const unsubTurmas = onSnapshot(collection(db, paths.turmas), (s) => {
            const list = s.docs.map(d => ({id: d.id, ...d.data()})).sort((a,b)=>a.nome.localeCompare(b.nome));
            setTurmas(list);
            if (list.length > 0 && !selectedTurmaId) setSelectedTurmaId(list[0].id);
        });

        const unsubCias = onSnapshot(collection(db, paths.companhias), (s) => setCompanhias(s.docs.map(d => ({id: d.id, ...d.data()})).sort((a,b)=>a.nome.localeCompare(b.nome))));
        const unsubPelotoes = onSnapshot(collection(db, paths.pelotoes), (s) => setPelotoes(s.docs.map(d => ({id: d.id, ...d.data()})).sort((a,b)=>a.nome.localeCompare(b.nome))));
        
        const qUsers = query(collection(db, paths.users)); 
        const unsubUsers = onSnapshot(qUsers, (s) => {
            const list = s.docs.map(d => ({id: d.id, ...d.data()})).sort((a,b)=> (a.nome || '').localeCompare(b.nome || ''));
            setTodosUsuarios(list);
            
            const listCadetes = list.filter(u => 
                !u.nivel || 
                ['cadete', 'cadete_academico', 'escalante'].includes(u.nivel) || 
                u.pelotao_id
            );
            setCadetes(listCadetes);
            setLoading(false);
        });

        return () => { unsubTurmas(); unsubCias(); unsubPelotoes(); unsubUsers(); };
    }, []);

    // --- HELPERS DE FILTRAGEM ---
    const filteredCompanhias = useMemo(() => {
        if (!selectedTurmaId) return companhias;
        return companhias.filter(c => c.turma_id === selectedTurmaId || !c.turma_id);
    }, [companhias, selectedTurmaId]);
    
    const filteredPelotoes = useMemo(() => {
        let result = pelotoes;
        if (selectedTurmaId) result = result.filter(p => p.turma_id === selectedTurmaId || !p.turma_id);
        if (selectedCiaId) result = result.filter(p => p.companhia_id === selectedCiaId);
        return result;
    }, [pelotoes, selectedTurmaId, selectedCiaId]);

    const pelotaoAtual = useMemo(() => pelotoes.find(p => p.id === selectedPelotaoId), [pelotoes, selectedPelotaoId]);

    const cadetesDoPelotao = useMemo(() => {
        if (!selectedPelotaoId) return [];
        let lista = cadetes.filter(c => String(c.pelotao_id).trim() === String(selectedPelotaoId).trim());
        if (pelotaoAtual?.id_cmt_pelotao) {
            lista = lista.filter(c => c.id !== pelotaoAtual.id_cmt_pelotao);
        }
        return lista.sort((a, b) => {
            const ordemA = parseInt(a.ordem_pelotao) || parseInt(a.ordem_antiguidade) || 9999;
            const ordemB = parseInt(b.ordem_pelotao) || parseInt(b.ordem_antiguidade) || 9999;
            if (ordemA !== ordemB) return ordemA - ordemB;
            return (a.nome || '').localeCompare(b.nome || '');
        });
    }, [cadetes, selectedPelotaoId, pelotaoAtual]);

    // --- FILTRAGEM NO MODAL DE ALOCAÇÃO ---
    const cadetesFiltradosParaAlocacao = useMemo(() => {
        return cadetesDisponiveis.filter(c => {
            const matchNome = c.nome.toLowerCase().includes(filtroNomeCadete.toLowerCase());
            let matchCia = true;
            if (filtroOrigemCia) {
               if (!c.pelotao_id) {
                   matchCia = false; 
               } else {
                   const pelotaoDoCadete = pelotoes.find(p => p.id === c.pelotao_id);
                   matchCia = pelotaoDoCadete && pelotaoDoCadete.companhia_id === filtroOrigemCia;
               }
            }
            let matchPelotao = true;
            if (filtroOrigemPelotao) {
                matchPelotao = c.pelotao_id === filtroOrigemPelotao;
            }
            return matchNome && matchCia && matchPelotao;
        });
    }, [cadetesDisponiveis, filtroNomeCadete, filtroOrigemCia, filtroOrigemPelotao, pelotoes]);

    // --- FUNÇÕES CRUD E ALOCAÇÃO ---
    const handleSaveGeneric = async (e) => {
        e.preventDefault();
        setProcessing(true);
        try {
            let collectionName = paths.turmas;
            let data = { nome: formData.nome };
            if (modalType === 'cia') { collectionName = paths.companhias; data.turma_id = selectedTurmaId; } 
            else if (modalType === 'pelotao') { collectionName = paths.pelotoes; data.turma_id = selectedTurmaId; data.companhia_id = selectedCiaId; }

            if (currentItem) { await updateDoc(doc(db, collectionName, currentItem.id), data); await logAuditoria(userProfile, `Editou ${modalType}`, { id: currentItem.id, ...data }); } 
            else { const newRef = doc(collection(db, collectionName)); await setDoc(newRef, { id: newRef.id, ...data, criado_em: new Date().toISOString() }); }
            setShowModal(false);
        } catch (err) { alert(err.message); } 
        finally { setProcessing(false); }
    };

    const handleDelete = async (collectionPath, id, typeName) => {
        if (!window.confirm(`Tem certeza que deseja excluir este(a) ${typeName}?`)) return;
        try { await deleteDoc(doc(db, collectionPath, id)); } catch (err) { alert(err.message); }
    };

    const handleOpenAlocarModal = async () => {
        const qAll = query(collection(db, paths.users));
        const snap = await getDocs(qAll);
        
        const listaDaTurma = snap.docs.map(d => ({id: d.id, ...d.data()}))
            .filter(u => 
                !['admin', 'professor', 'soe', 'cmt_pelotao'].includes(u.nivel) && 
                (u.turma_id === selectedTurmaId) 
            )
            .sort((a,b) => (parseInt(a.ordem_antiguidade) || 999) - (parseInt(b.ordem_antiguidade) || 999));
            
        setCadetesDisponiveis(listaDaTurma);
        setCadeteParaAlocar('');
        setOrdemPelotaoManual('');
        setFiltroNomeCadete('');
        setFiltroOrigemCia('');
        setFiltroOrigemPelotao('');
        setModalType('alocarCadete');
        setShowModal(true);
    };

    const handleAlocarCadete = async (e) => {
        e.preventDefault();
        if (!cadeteParaAlocar || !selectedPelotaoId) return alert("Selecione cadete e pelotão.");
        setProcessing(true);
        try {
            const userRef = doc(db, paths.users, cadeteParaAlocar);
            await updateDoc(userRef, {
                turma_id: selectedTurmaId || '',
                turma_nome: turmas.find(t => t.id === selectedTurmaId)?.nome || '',
                pelotao_id: selectedPelotaoId,
                pelotao_nome: pelotoes.find(p => p.id === selectedPelotaoId)?.nome || '',
                ordem_pelotao: ordemPelotaoManual ? parseInt(ordemPelotaoManual) : null,
                atualizado_em: new Date().toISOString()
            });
            setShowModal(false);
        } catch (err) { alert(err.message); }
        finally { setProcessing(false); }
    };

    const handleDesalocar = async (id) => {
        if(!window.confirm("Remover cadete do pelotão?")) return;
        try { await updateDoc(doc(db, paths.users, id), { turma_id: '', turma_nome: '', pelotao_id: '', pelotao_nome: '', ordem_pelotao: null }); } catch(e) { alert(e.message); }
    };

    // --- NOVA FUNÇÃO DE IMPORTAÇÃO CSV PARA ALOCAÇÃO ---
    const handleImportCSVAlocacao = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        if (!selectedTurmaId) {
            alert("Selecione uma Turma primeiro para realizar a importação.");
            if(fileInputRef.current) fileInputRef.current.value = "";
            return;
        }

        if (!window.confirm("Confirmar a importação em lote das alocações para esta turma? Os nomes também serão atualizados caso contenham caracteres inválidos no banco.")) return;

        setProcessing(true);
        setImportProgress("Lendo arquivo...");

        const reader = new FileReader();
        // Usamos ISO-8859-1 para garantir a leitura correta de acentos (ANSI)
        reader.readAsText(file, 'ISO-8859-1'); 
        
        reader.onload = async (e) => {
            const text = e.target.result;
            const lines = text.split(/\r?\n/).filter(l => l.trim() !== "");

            let successCount = 0;
            let errorDetails = [];
            const turmaObj = turmas.find(t => t.id === selectedTurmaId);

            const normalizeString = (str) => {
                if (!str) return "";
                return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
            };

            try {
                const batch = writeBatch(db);
                let operacoesBatch = 0;

                for (let i = 1; i < lines.length; i++) {
                    setImportProgress(`Processando linha ${i} de ${lines.length - 1}...`);
                    const cols = lines[i].split(';');
                    if (cols.length < 5) continue;

                    const classifRaw = cols[0].trim();
                    const reRaw = cols[1].trim();
                    
                    // Extrai o nome do CSV, remove aspas extras e deixa em maiúsculo
                    const nomeCsvCorreto = cols[2] ? cols[2].trim().replace(/^"|"$/g, '').replace(/""/g, '"').toUpperCase() : "";
                    
                    const pelRawDisplay = cols[4].trim().replace(/^"|"$/g, '').replace(/""/g, '"');
                    const pelRawNorm = normalizeString(cols[4]);

                    const cadete = todosUsuarios.find(u => u.re === reRaw || u.matricula === reRaw);
                    if (!cadete) {
                        errorDetails.push(`Linha ${i + 1}: Cadete RE ${reRaw} não localizado.`);
                        continue;
                    }

                    const pelotao = pelotoes.find(p => p.turma_id === selectedTurmaId && normalizeString(p.nome) === pelRawNorm);
                    
                    if (!pelotao) {
                        errorDetails.push(`Linha ${i + 1}: Pelotão '${pelRawDisplay}' não localizado nesta turma.`);
                        continue;
                    }

                    // Prepara a atualização da alocação
                    const updatePayload = {
                        turma_id: selectedTurmaId,
                        turma_nome: turmaObj?.nome || '',
                        pelotao_id: pelotao.id,
                        pelotao_nome: pelotao.nome,
                        ordem_pelotao: parseInt(classifRaw) || null,
                        atualizado_em: new Date().toISOString()
                    };

                    // Se encontrou um nome no CSV, atualiza o nome no banco para corrigir os caracteres bugados
                    if (nomeCsvCorreto) {
                        updatePayload.nome = nomeCsvCorreto;
                    }

                    const userRef = doc(db, paths.users, cadete.id);
                    batch.update(userRef, updatePayload);

                    successCount++;
                    operacoesBatch++;

                    if (operacoesBatch >= 400) {
                        await batch.commit();
                        operacoesBatch = 0;
                    }
                }

                if (operacoesBatch > 0) {
                    await batch.commit();
                }

                if (errorDetails.length > 0) {
                    alert(`Importação finalizada.\nSucesso: ${successCount}\n\nErros:\n${errorDetails.join('\n')}`);
                } else {
                    alert(`Sucesso! ${successCount} cadetes foram distribuídos nos pelotões e tiveram seus nomes corrigidos.`);
                    setShowModal(false);
                }

            } catch (error) {
                console.error("Erro na importação:", error);
                alert("Ocorreu um erro ao importar: " + error.message);
            } finally {
                setProcessing(false);
                setImportProgress("");
                if(fileInputRef.current) fileInputRef.current.value = "";
            }
        };
    };

    const handleOpenComandoModal = (tipo) => {
        setModalType(tipo);
        setUsuarioSelecionadoComando('');
        if (tipo === 'escalante') { setListaUsuariosDropdown(cadetesDoPelotao); } 
        else { setListaUsuariosDropdown(todosUsuarios); }
        setShowModal(true);
    };

    const handleSalvarComando = async (e) => {
        e.preventDefault();
        if (!selectedPelotaoId || !usuarioSelecionadoComando) return;
        setProcessing(true);
        try {
            const usuario = todosUsuarios.find(u => u.id === usuarioSelecionadoComando);
            const pelotaoRef = doc(db, paths.pelotoes, selectedPelotaoId);
            const updateData = {};
            if (modalType === 'cmt_pelotao') {
                updateData.nome_cmt_pelotao = usuario.nome;
                updateData.posto_cmt_pelotao = usuario.posto || 'Oficial';
                updateData.id_cmt_pelotao = usuario.id;
            } else if (modalType === 'escalante') {
                updateData.nome_escalante = usuario.nome;
                updateData.posto_escalante = usuario.posto || 'Cadete';
                updateData.id_escalante = usuario.id;
            }
            await updateDoc(pelotaoRef, updateData);
            setShowModal(false);
        } catch (err) { alert(err.message); }
        finally { setProcessing(false); }
    };

    const openModal = (type, item=null) => {
        setModalType(type);
        setCurrentItem(item);
        setFormData(item ? { ...item } : { nome: '' });
        setShowModal(true);
    };
    
    const FilterChip = ({ label, active, onClick, colorClass = "blue" }) => {
        const baseClass = "px-3 py-1.5 rounded-md text-xs font-medium border transition-all duration-200 whitespace-nowrap shadow-sm";
        const activeClass = `bg-${colorClass}-600 text-white border-${colorClass}-600 ring-1 ring-${colorClass}-200`;
        const inactiveClass = "bg-white text-gray-600 border-gray-200 hover:bg-gray-50 hover:border-gray-300";
        return <button onClick={onClick} className={`${baseClass} ${active ? activeClass : inactiveClass}`}>{label}</button>;
    };

    if (loading) return <LoadingSpinner />;

    return (
        <div className="space-y-6 animate-fade-in bg-gray-50 min-h-screen p-6">
            <header className="flex justify-between items-end border-b border-gray-200 pb-4">
                <div><h1 className="text-2xl font-bold text-gray-800">Gerenciar Efetivo</h1><p className="text-sm text-gray-500 mt-1">Gestão estrutural e alocação de pessoal.</p></div>
                <div className="flex bg-white rounded-lg p-1 shadow-sm border border-gray-200">{['turmas', 'companhias', 'pelotoes', 'cadetes'].map(tab => (<button key={tab} onClick={() => setActiveTab(tab)} className={`px-4 py-1.5 rounded-md text-sm font-medium transition-all capitalize ${activeTab === tab ? 'bg-blue-600 text-white shadow-sm' : 'text-gray-500 hover:bg-gray-50 hover:text-gray-700'}`}>{tab}</button>))}</div>
            </header>

            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 min-h-[500px]">
                
                {/* 1. TURMAS */}
                {activeTab === 'turmas' && (
                    <div className="space-y-4">
                        <div className="flex justify-between items-center"><h3 className="font-bold text-gray-700">Listagem de Turmas</h3><Button onClick={() => openModal('turma')} variant="success" className="text-xs px-3 py-2 flex items-center gap-2 shadow-sm"><PlusIcon /> Nova Turma</Button></div>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                            {turmas.map(t => (
                                <div key={t.id} className="p-4 bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow group relative">
                                    <h4 className="font-bold text-gray-800 text-lg">{t.nome}</h4>
                                    
                                    <div className="absolute top-4 right-4 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                                        <button onClick={() => openModal('turma', t)} className="text-blue-600 hover:bg-blue-50 p-1 rounded"><EditIcon /></button>
                                        <button onClick={() => handleDelete(paths.turmas, t.id, 'Turma')} className="text-red-600 hover:bg-red-50 p-1 rounded"><TrashIcon /></button>
                                    </div>
                                </div>
                            ))}
                        </div>
                        {turmas.length === 0 && <div className="text-center text-gray-400 py-10">Nenhuma turma cadastrada.</div>}
                    </div>
                )}

                {/* 2. COMPANHIAS */}
                {activeTab === 'companhias' && (
                    <div className="space-y-4">
                        <div className="flex justify-between items-center bg-gray-50 p-3 rounded-lg border border-gray-200"><div className="flex items-center gap-2 overflow-x-auto scrollbar-hide"><span className="text-[10px] font-bold text-gray-400 uppercase w-12 flex-shrink-0"><FilterIcon /> Filtro</span>{turmas.map(t => (<FilterChip key={t.id} label={t.nome} active={selectedTurmaId === t.id} onClick={() => setSelectedTurmaId(t.id)} />))}</div><Button onClick={() => openModal('cia')} variant="success" className="text-xs px-3 py-2 flex-shrink-0 ml-4 shadow-sm flex items-center gap-2"><PlusIcon /> Nova CIA</Button></div>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">{filteredCompanhias.map(c => (<div key={c.id} className="p-4 bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow group relative"><h4 className="font-bold text-gray-800 text-lg">{c.nome}</h4><span className="text-xs bg-blue-50 text-blue-600 px-2 py-1 rounded mt-2 inline-block border border-blue-100">{turmas.find(t=>t.id===c.turma_id)?.nome}</span><div className="absolute top-4 right-4 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity"><button onClick={() => openModal('cia', c)} className="text-blue-600 hover:bg-blue-50 p-1 rounded"><EditIcon /></button><button onClick={() => handleDelete(paths.companhias, c.id, 'Companhia')} className="text-red-600 hover:bg-red-50 p-1 rounded"><TrashIcon /></button></div></div>))}</div>
                    </div>
                )}

                {/* 3. PELOTÕES */}
                {activeTab === 'pelotoes' && (
                    <div className="space-y-4">
                        <div className="bg-gray-50 p-3 rounded-lg border border-gray-200 space-y-2"><div className="flex items-center gap-2 overflow-x-auto scrollbar-hide"><span className="text-[10px] font-bold text-gray-400 uppercase w-12 flex-shrink-0"><FilterIcon /> Turma</span>{turmas.map(t => (<FilterChip key={t.id} label={t.nome} active={selectedTurmaId === t.id} onClick={() => { setSelectedTurmaId(t.id); setSelectedCiaId(''); }} />))}</div>{selectedTurmaId && (<div className="flex items-center gap-2 overflow-x-auto scrollbar-hide border-t border-gray-200 pt-2"><span className="text-[10px] font-bold text-gray-400 uppercase w-12 flex-shrink-0">CIA</span><FilterChip label="Todas" active={!selectedCiaId} onClick={() => setSelectedCiaId('')} colorClass="green" />{filteredCompanhias.map(c => (<FilterChip key={c.id} label={c.nome} active={selectedCiaId === c.id} onClick={() => setSelectedCiaId(c.id)} colorClass="green" />))}</div>)}</div>
                        <div className="flex justify-end"><Button onClick={() => openModal('pelotao')} variant="success" className="text-xs px-3 py-2 shadow-sm flex items-center gap-2"><PlusIcon /> Novo Pelotão</Button></div>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">{filteredPelotoes.map(p => (<div key={p.id} className="p-4 bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow group relative"><h4 className="font-bold text-gray-800 text-lg">{p.nome}</h4><div className="flex flex-wrap gap-1 mt-2"><span className="text-[10px] bg-green-50 text-green-700 px-2 py-0.5 rounded border border-green-100">{companhias.find(c=>c.id===p.companhia_id)?.nome}</span><span className="text-[10px] bg-blue-50 text-blue-700 px-2 py-0.5 rounded border border-blue-100">{turmas.find(t=>t.id===p.turma_id)?.nome}</span></div><div className="absolute top-4 right-4 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity"><button onClick={() => openModal('pelotao', p)} className="text-blue-600 hover:bg-blue-50 p-1 rounded"><EditIcon /></button><button onClick={() => handleDelete(paths.pelotoes, p.id, 'Pelotão')} className="text-red-600 hover:bg-red-50 p-1 rounded"><TrashIcon /></button></div></div>))}</div>
                    </div>
                )}
                
                {/* 4. CADETES (ALOCAÇÃO) */}
                {activeTab === 'cadetes' && (
                    <div className="space-y-6">
                        <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 space-y-3 shadow-sm">
                            <div className="flex items-center gap-3 overflow-x-auto scrollbar-hide">
                                <span className="text-[10px] font-bold text-gray-400 uppercase w-16 flex-shrink-0 flex items-center gap-1"><FilterIcon /> Turma</span>
                                <div className="flex gap-2">{turmas.map(t => (<FilterChip key={t.id} label={t.nome} active={selectedTurmaId === t.id} onClick={() => { setSelectedTurmaId(t.id); setSelectedCiaId(''); setSelectedPelotaoId(''); }} />))}</div>
                            </div>
                            {selectedTurmaId && (
                                <div className="flex items-center gap-3 overflow-x-auto scrollbar-hide border-t border-gray-200 pt-3 animate-fade-in">
                                    <span className="text-[10px] font-bold text-gray-400 uppercase w-16 flex-shrink-0">CIA</span>
                                    <div className="flex gap-2"><FilterChip label="Todas" active={!selectedCiaId} onClick={() => { setSelectedCiaId(''); setSelectedPelotaoId(''); }} colorClass="green" />{filteredCompanhias.map(c => (<FilterChip key={c.id} label={c.nome} active={selectedCiaId === c.id} onClick={() => { setSelectedCiaId(c.id); setSelectedPelotaoId(''); }} colorClass="green" />))}</div>
                                </div>
                            )}
                            {(selectedTurmaId || selectedCiaId) && (
                                <div className="flex items-center gap-3 overflow-x-auto scrollbar-hide border-t border-gray-200 pt-3 animate-fade-in">
                                    <span className="text-[10px] font-bold text-gray-400 uppercase w-16 flex-shrink-0">Pelotão</span>
                                    <div className="flex gap-2">{filteredPelotoes.map(p => (<FilterChip key={p.id} label={p.nome} active={selectedPelotaoId === p.id} onClick={() => setSelectedPelotaoId(p.id)} colorClass="purple" />))}</div>
                                </div>
                            )}
                        </div>

                        {selectedPelotaoId ? (
                            <>
                                <div className="bg-blue-50/50 border border-blue-100 rounded-xl p-4 animate-fade-in">
                                    <h4 className="text-xs font-bold text-blue-800 uppercase tracking-wide mb-3 flex items-center gap-2"><BadgeIcon /> Comando do Pelotão</h4>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div className="flex items-center justify-between bg-white p-3 rounded-lg border border-blue-50 shadow-sm">
                                            <div className="flex items-center gap-3"><div className="p-2 bg-yellow-50 rounded-full text-yellow-500"><StarIcon /></div><div><p className="text-[10px] text-gray-400 font-bold uppercase">Comandante</p><p className="text-sm font-semibold text-gray-800">{pelotaoAtual?.posto_cmt_pelotao} {pelotaoAtual?.nome_cmt_pelotao || <span className="text-gray-400 font-normal italic">Não Definido</span>}</p></div></div>
                                            <button onClick={() => handleOpenComandoModal('cmt_pelotao')} className="text-xs font-medium text-blue-600 hover:text-blue-800 bg-blue-50 px-2 py-1 rounded">Alterar</button>
                                        </div>
                                        <div className="flex items-center justify-between bg-white p-3 rounded-lg border border-blue-50 shadow-sm">
                                            <div className="flex items-center gap-3"><div className="p-2 bg-blue-50 rounded-full text-blue-500"><BadgeIcon /></div><div><p className="text-[10px] text-gray-400 font-bold uppercase">Escalante</p><p className="text-sm font-semibold text-gray-800">{pelotaoAtual?.posto_escalante} {pelotaoAtual?.nome_escalante || <span className="text-gray-400 font-normal italic">Não Definido</span>}</p></div></div>
                                            <button onClick={() => handleOpenComandoModal('escalante')} className="text-xs font-medium text-blue-600 hover:text-blue-800 bg-blue-50 px-2 py-1 rounded">Alterar</button>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <div className="flex justify-between items-end mb-2 px-1">
                                        <div><h3 className="font-bold text-gray-800 text-lg flex items-center gap-2">Efetivo Alocado <span className="px-2 py-0.5 bg-purple-100 text-purple-700 rounded text-xs">{pelotaoAtual?.nome}</span></h3></div>
                                        <Button onClick={handleOpenAlocarModal} variant="success" className="text-xs px-3 py-2 flex items-center gap-2 shadow-sm"><UserAddIcon /> Alocar Cadete</Button>
                                    </div>
                                    <div className="border border-gray-200 rounded-lg overflow-hidden bg-white shadow-sm">
                                        <table className="min-w-full text-sm">
                                            <thead className="bg-gray-50 border-b border-gray-200 text-gray-500 text-xs uppercase font-semibold"><tr><th className="p-3 text-center w-16">Ordem</th><th className="p-3 text-left w-32">RE / Matrícula</th><th className="p-3 text-left">Nome de Guerra / Completo</th><th className="p-3 text-right">Ações</th></tr></thead>
                                            <tbody className="divide-y divide-gray-100">
                                                {cadetesDoPelotao.map((c) => (
                                                    <tr key={c.id} className="hover:bg-gray-50 transition-colors group">
                                                        <td className="p-3 text-center font-bold text-gray-700 bg-gray-50/50">{c.ordem_pelotao || c.ordem_antiguidade || '-'}</td>
                                                        <td className="p-3 font-mono text-gray-600 text-xs">{c.re || c.matricula || '-'}</td>
                                                        <td className="p-3 font-semibold text-gray-800">{c.nome}</td>
                                                        <td className="p-3 text-right"><button onClick={() => handleDesalocar(c.id)} className="text-gray-400 hover:text-red-600 text-xs font-medium border border-gray-200 px-2 py-1 rounded bg-white hover:bg-red-50 hover:border-red-200 transition-all opacity-0 group-hover:opacity-100">Desalocar</button></td>
                                                    </tr>
                                                ))}
                                                {cadetesDoPelotao.length === 0 && <tr><td colSpan="4" className="p-8 text-center text-gray-400 italic">Nenhum cadete alocado neste pelotão.</td></tr>}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="p-12 flex flex-col items-center justify-center text-center border-2 border-dashed border-gray-200 rounded-lg bg-gray-50/50"><UserAddIcon className="w-10 h-10 text-gray-300 mb-2"/><span className="text-gray-400 font-medium">Selecione um Pelotão acima para gerenciar o efetivo.</span></div>
                        )}
                    </div>
                )}
            </div>

            {/* Modais */}
            <Modal 
                show={showModal} 
                onClose={() => setShowModal(false)} 
                title={modalType === 'alocarCadete' ? 'Alocar Cadete ao Pelotão' : modalType === 'cmt_pelotao' ? 'Definir Comandante' : modalType === 'escalante' ? 'Definir Escalante' : `Gerenciar ${modalType}`} 
                size={modalType === 'alocarCadete' ? '7xl' : 'md'}
            >
                {modalType === 'alocarCadete' ? (
                    <form onSubmit={handleAlocarCadete} className="grid grid-cols-2 gap-6">
                        
                        {/* COLUNA ESQUERDA: LISTA DE CADETES (ORIGEM) */}
                        <div className="border-r pr-6 space-y-3 flex flex-col h-[550px]"> 
                            <div className="flex justify-between items-end border-b pb-1">
                                <h4 className="text-sm font-bold text-gray-700">1. Origem: Turma {turmas.find(t=>t.id===selectedTurmaId)?.nome}</h4>
                            </div>

                            {/* --- BOTÃO DE IMPORTAR CSV ADICIONADO AQUI DENTRO DO MODAL --- */}
                            <div className="bg-blue-50/50 border border-blue-200 rounded-lg p-3 flex flex-col gap-2 shadow-sm">
                                <div className="flex justify-between items-center">
                                    <span className="text-xs font-bold text-blue-800">Alocação em Massa (CSV)</span>
                                    <input type="file" accept=".csv" ref={fileInputRef} style={{display: 'none'}} onChange={handleImportCSVAlocacao} />
                                    <Button type="button" onClick={() => fileInputRef.current && fileInputRef.current.click()} variant="outline" className="text-xs bg-white border-blue-300 text-blue-700 hover:bg-blue-100 flex items-center gap-1 py-1 px-2" disabled={processing}>
                                        <UploadIcon /> Importar CSV
                                    </Button>
                                </div>
                                {processing && importProgress && <span className="text-xs text-blue-600 font-bold animate-pulse">{importProgress}</span>}
                            </div>
                            
                            {/* Filtros de Origem */}
                            <div className="grid grid-cols-2 gap-2 mb-2">
                                <select className="w-full border p-1 rounded text-xs" value={filtroOrigemCia} onChange={e => {setFiltroOrigemCia(e.target.value); setFiltroOrigemPelotao('');}}>
                                    <option value="">Todas Cias</option>
                                    {filteredCompanhias.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
                                </select>
                                <select className="w-full border p-1 rounded text-xs" value={filtroOrigemPelotao} onChange={e => setFiltroOrigemPelotao(e.target.value)} disabled={!filtroOrigemCia}>
                                    <option value="">Todos Pelotões</option>
                                    {pelotoes.filter(p => p.companhia_id === filtroOrigemCia).map(p => <option key={p.id} value={p.id}>{p.nome}</option>)}
                                </select>
                            </div>

                            <input className="w-full border p-2 rounded text-sm mb-2" placeholder="Filtrar por nome..." value={filtroNomeCadete} onChange={e => setFiltroNomeCadete(e.target.value)} />
                            
                            <div className="border rounded flex-1 overflow-y-auto bg-gray-50 p-2 space-y-1">
                                {cadetesFiltradosParaAlocacao.map(c => (
                                    <div 
                                        key={c.id} 
                                        onClick={() => setCadeteParaAlocar(c.id)}
                                        className={`p-2 rounded text-sm cursor-pointer flex justify-between items-center transition-colors ${cadeteParaAlocar === c.id ? 'bg-blue-600 text-white' : 'bg-white border hover:bg-gray-100'}`}
                                    >
                                        <div className="flex flex-col">
                                            <span className="font-bold">{c.nome}</span>
                                            <span className={`text-[10px] ${cadeteParaAlocar === c.id ? 'text-blue-200' : 'text-gray-500'}`}>{c.re || c.matricula}</span>
                                        </div>
                                        <span className={`text-[10px] px-2 py-0.5 rounded flex-shrink-0 ml-2 ${cadeteParaAlocar === c.id ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-600'}`}>
                                            {c.pelotao_nome || 'Sem Pelotão'}
                                        </span>
                                    </div>
                                ))}
                                {cadetesFiltradosParaAlocacao.length === 0 && <div className="text-center text-xs text-gray-400 mt-4">Nenhum cadete encontrado.</div>}
                            </div>
                        </div>

                        {/* COLUNA DIREITA: DESTINO E ORDEM */}
                        <div className="space-y-4 flex flex-col justify-center h-[550px]">
                            <div className="bg-blue-50 p-6 rounded-lg border border-blue-200 text-center shadow-sm">
                                <h4 className="text-xs font-bold text-blue-800 uppercase mb-2">Destino Selecionado</h4>
                                <div className="text-2xl font-bold text-blue-900">{pelotaoAtual?.nome}</div>
                                <div className="text-sm text-blue-600 mt-1">{turmas.find(t=>t.id===selectedTurmaId)?.nome}</div>
                            </div>
                            
                            {cadeteParaAlocar && (
                                <div className="animate-fade-in bg-white p-4 border rounded-lg shadow-sm">
                                    <div className="mb-4 text-center">
                                        <span className="text-xs text-gray-500 uppercase font-bold">Transferindo:</span>
                                        <div className="font-bold text-gray-800">{cadetesDisponiveis.find(c=>c.id===cadeteParaAlocar)?.nome}</div>
                                    </div>

                                    <label className="block text-sm font-medium text-gray-700 mb-1">Definir Nº de Ordem (Opcional)</label>
                                    <input 
                                        type="number" 
                                        className="w-full border p-2 rounded-lg text-sm text-center font-bold"
                                        placeholder="Ex: 1, 2, 3..."
                                        value={ordemPelotaoManual}
                                        onChange={(e) => setOrdemPelotaoManual(e.target.value)}
                                    />
                                    <p className="text-xs text-gray-500 mt-2 text-center">Deixe em branco para usar antiguidade padrão.</p>
                                    
                                    <Button type="submit" variant="primary" className="w-full mt-6 flex justify-center items-center gap-2 py-3" disabled={processing}>
                                        Confirmar Transferência <ArrowRightIcon className="w-4 h-4 text-white"/>
                                    </Button>
                                </div>
                            )}
                            
                            {!cadeteParaAlocar && <div className="flex flex-col items-center justify-center text-gray-300 h-40 italic text-sm"><span>Selecione um cadete na lista<br/>para iniciar a transferência.</span></div>}
                        </div>
                    </form>
                ) : (modalType === 'cmt_pelotao' || modalType === 'escalante') ? (
                    <form onSubmit={handleSalvarComando} className="space-y-4">
                        <div className="bg-blue-50 p-3 rounded text-sm text-blue-800 border border-blue-200 flex items-center gap-2"><BadgeIcon /> <span>Destino: <strong>{pelotaoAtual?.nome}</strong></span></div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">{modalType === 'alocarCadete' ? 'Selecione o Cadete' : 'Selecione o Usuário'}</label>
                            <select className="w-full border p-2 rounded-lg bg-white shadow-sm focus:ring-2 focus:ring-blue-500 outline-none text-sm" value={modalType === 'alocarCadete' ? cadeteParaAlocar : usuarioSelecionadoComando} onChange={e => modalType === 'alocarCadete' ? setCadeteParaAlocar(e.target.value) : setUsuarioSelecionadoComando(e.target.value)} required>
                                <option value="">-- Buscar na Lista --</option>
                                {(modalType === 'escalante' ? listaUsuariosDropdown : todosUsuarios).map(u => (<option key={u.id} value={u.id}>{u.nome} ({u.nivel || 'N/A'})</option>))}
                            </select>
                        </div>
                        <div className="flex justify-end pt-4 border-t gap-2"><Button variant="secondary" onClick={() => setShowModal(false)} type="button">Cancelar</Button><Button type="submit" variant="primary" disabled={processing}>Confirmar</Button></div>
                    </form>
                ) : (
                    <form onSubmit={handleSaveGeneric} className="space-y-4">
                        <div><label className="block text-sm font-medium text-gray-700">Nome</label><input className="w-full border p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" value={formData.nome || ''} onChange={e => setFormData({...formData, nome: e.target.value})} required placeholder={modalType === 'turma' ? "Ex: Aspirantes 2026" : "Ex: 1º Pelotão"} /></div>
                        <div className="flex justify-end pt-4 border-t gap-2"><Button variant="secondary" onClick={() => setShowModal(false)} type="button">Cancelar</Button><Button type="submit" variant="primary" disabled={processing}>Salvar</Button></div>
                    </form>
                )}
            </Modal>
        </div>
    );
};